import { SET_NOTIFICATION, APPEND_NOTIFICATIONS } from "../actions/alert";
import produce from "immer";
const INITIAL_STATE = {
  list: [],
  page: 1,
  hasMore: true
};

export const alertReducer = produce((draft, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      draft.list = action.payload.list;
      draft.page = action.payload.page;
      draft.hasMore = action.payload.hasMore;
      break;

    case APPEND_NOTIFICATIONS:
      draft.list.push(...action.payload.list);
      draft.page = action.payload.page;
      draft.hasMore = action.payload.hasMore;
      break;

    default:
      break;
  }
}, INITIAL_STATE);